export default {
    Name: 'Emri',
    'Phone Number': 'Numri i telefonit',
    Phone: 'Telefon',
    Email: 'Email',
    Actions: 'Veprimet',
    Code: 'Kodi',
    'AMF Code': 'Kodi AMF',
    Username: 'Emri i përdoruesit',
    Password: 'Fjalëkalimi',
    'Confirm Password': 'Konfirmo fjalëkalimin',
    'AMF Username': 'Emri i përdoruesit AMF',
    'AMF Password': 'Fjalëkalimi AMF',
    Serial: 'Seriali',
    'Policy Holder': 'Mbajtës i policës',
    'Product Code': 'Kodi i produktit',
    Currency: 'Valuta',
    Status: 'Statusi',
    'Premium Gross': 'Primi Bruto',
    'Premium Net': 'Primi Neto',
    'Issued Date': 'Data e lëshimit',
    'Start Date': 'Data e fillimit',
    'End Date': 'Data e përfundimit',
    Agency: 'Agjencia',
    'Find Agency by Tax Number': 'Gjeni agjencinë sipas numrit tatimor',
    'Agency Commission Rate': 'Norma e komisionit të agjencisë',
    Agent: 'Agjent',
    Intermediary: 'Ndërmjetës',
    'Intermediary Commission Rate': 'Norma e komisionit ndërmjetës',
    Underwriter: 'Nënshkrues',
    Contact: 'Kontakti',
    'Select Departament': 'Zgjidh departamentin',
    'All Departments': 'Të gjitha departamentet',
    'Health Department': 'Departamenti i Shëndetësisë',
    'Property Department': 'Departamenti i Pronës',
    'Motor Department': 'Departamenti i motorëve',
    'Tax Number': 'Numri ID',
    'Display Name': 'Emri i plotë',
    Country: 'Vendi',
    City: 'Qyteti',
    'Postal Code': 'Kodi Postar',
    'Street Address': 'Adresa e rrugës',
    'Street Address 2': 'Adresa e rrugës 2',
    Duration: 'Kohëzgjatja',
    'Distribution Channel': 'Kanali i Shpërndarjes',
    Broker: 'Broker',
    Bank: 'Banka',
    'First Name': 'Emri',
    'Last Name': 'Mbiemri',
    Customer: 'Klienti',
    Commission: 'Komisioni',
    Notes: 'Shënime',
    'Choose Type': 'Zgjidh llojin',
    Person: 'Personi',
    Organization: 'Organizata',
    Local: 'Lokal',
    'Business Size Type': 'Lloji i madhësisë së biznesit',
    'Business Size': 'Madhësia e biznesit',
    'Legal Form Type': 'Lloji i formës ligjore',
    'Sector Type': 'Lloji i sektorit',
    'Organization Ownership Type': 'Lloji i pronësisë së subjektit',
    Administrator: 'Administratori',
    Active: 'Aktiv',
    'Business Description': 'Përshkrimi i biznesit',
    "Father's Name": 'Emri i babait',
    Birthday: 'Ditëlindja',
    'Choose Gender': 'Zgjidhni gjininë',
    Gender: 'Gjinia',
    Female: 'Femër',
    Male: 'Mashkull',
    Other: 'Tjetër',
    'Hospital Type': 'Lloji i spitalit',
    Website: 'Website',
    'Insurance Sector Type': 'Lloji i Sektorit të Sigurimeve',
    'Tax Rate': 'Norma e tatimit',
    'Agent Commission Rate': 'Norma e komisionit të agjentit',
    'Bonus Commission Rate': 'Norma e komisionit të bonusit',
    'Bonus Commission Rate Cap': 'Kapi i normës së komisionit të bonusit',
    'AMF Contribution Rate': 'Norma e kontributit të AMF',
    'Dynamic Durations': 'Kohëzgjatjet dinamike',
    Group: 'Grupi',
    'Transit Type': 'Lloji i transitit',
    'Security Measures': 'Masat e sigurisë',
    Description: 'Përshkrim',
    'Location of the insured property': 'Vendndodhja e pasurise së siguruar',
    'Special Coverage': 'Mbulim i veçantë',
    Years: 'Vite',
    Months: 'Muaj',
    Days: 'Ditë',
    Default: 'E parazgjedhur',
    'Serial Start': 'Fillimi i serialit',
    'Serial End': 'Fundi serial',
    Destination: 'Destinacioni',
    'Gjithe Europa': 'Gjithe Europa',
    'Insured Period': 'Periudha e Sigurimit',
    Beneficiary: 'Përfituesi',
    'The policyholder is the same as the beneficiary': 'Policmbajtësi është i njëjtë me përfituesin',
    'Completion Date': 'Data e përfundimit',
    'Write the Serial': 'Shkruaj serialin',
    'Vehicle Value': 'Vlera e automjetit',
    Payment: 'Pagesa',
    'Payment Method': 'Metoda e pagesës',
    'Seriali TPL': 'Seriali TPL',
    'Gross Premium': 'Primi Bruto',
    Address: 'Adresë',
    Clinic: 'Klinika',
    Dentistry: 'Stomatologji',
    Hospital: 'Spitali',
    Laboratory: 'Laborator',
    Optical: 'Optike',
    Pharmacy: 'Farmacia',
    Physiotherapy: 'Fizioterapi',
    'Large Enterprise': 'Ndërmarrje e madhe',
    'Small Enterprise no VAT': 'Ndërmarrja e vogël pa TVSH',
    'Small Enterprise with VAT': 'Ndërmarrja e vogël me TVSH',
    'Small-Medium Enterprise': 'Ndërmarrje e Vogël-Mesme',
    'VIP Enterprise': 'Ndërmarrja VIP',
    'Person Fizik': 'Personi Fizik',
    'Shoqëri me përgjegjësi të kufizuar': 'Shoqëri me përgjegjësi të kufizuara',
    'Organizatë jo fitimprurëse': 'Organizata jo fitimprurëse',
    'Gjithë të tjerat': 'Gjithë të tjerat',
    'Ent Publik': 'Ent Publik',
    'Shoqëri Aksionare': 'Shoqëri Aksionare',
    'Construction sector': 'Sektori i ndërtimit',
    'Other sectors': 'Sektorë të tjerë',
    'Production sector': 'Sektori i prodhimit',
    'Service sector': 'Sektori i Sherbimeve',
    'Trade sector': 'Sektori i tregtisë',
    'Transport sector': 'Sektori i transportit',
    Foreign: 'I huaj',
    Government: 'Qeveria',
    'Local foreign': 'I huaj vendas',
    'Health department': 'Departamenti i Shëndetësisë',
    'Marine department': 'Departamenti i Marinës',
    'Motor department': 'Departamenti Motorik',
    'Property department': 'Departamenti i Pronës',
    Classification: 'Klasifikimi',
    Category: 'Kategoria',
    Engine: 'Motor',
    Capacity: 'Kapaciteti',
    UXH: 'UXH',
    CSH: 'CSH',
    eSigurime: 'eSigurime',
    ID: 'ID',
    Albania: 'Shqipëria',
    'The Balkans': 'Ballkani',
    Europe: 'Evropa',
    '1 Year': '1 vit',
    '1 Month': '1 muaj',
    Location: 'Vendndodhja',
    'Border Vehicle Category': 'Kategoria e automjeteve kufitare',
    Autovetura: 'Autovetura',
    Motocikleta: 'Motorcikleta nga 50-149.9 cc',
    Motokarro: 'Motoricikleta mbi 150 cc',
    'Kamion nga 15-34.99 KV': 'Kamion nga 15-34.99 KV',
    'Kamion nga 35 KV e larte': 'Kamion nga 35 KV e larte',
    Ciklomotor: 'Motorciklete 49 cc',
    Autobus: 'Autobus',
    'Rimorkio kamioni': 'Rimorkio kamioni',
    'Rimorkio autobusi': 'Rimorkio autobusi',
    'Rimorkio te tjera': 'Rimorkio te tjera',
    'Currency Type': 'Lloji i monedhës',
    'Tirane Kolaudim': 'Tirane Kolaudim',
    'Dega Qendrore Tirane': 'Dega Qendrore Tirane',
    'Fiscalization: Bizzness Unit': 'Fiskalizimi: Njësia e Biznesit',
    'Fiscalization: Operator Code': 'Fiskalizimi: Kodi i Operatorit',
    'Bank Account': 'Llogari bankare',
    'Gjithe Bota': 'Gjithe Bota',
    'Gjithe Bota perjashtuar USA & Canada': 'Gjithe Bota perjashtuar SHBA & Kanada',
    Turkey: 'Turqia',
    Agjent: 'Agjent',
    Banke: 'Banke',
    Type: 'Lloji',
    Individual: 'Individual',
    'Travel Cancelation': 'Anulimi i udhëtimit',
    'Confirmation Date': 'Data e konfirmimit',
    'Coverages Options': 'Opsionet e mbulimit',
    'Luggage Delay': 'Vonesë e bagazhit',
    '150 Euro': '150 euro',
    '500 Euro': '500 euro',
    '800 Euro': '800 euro',
    '1000 Euro': '1000 euro',
    '1500 Euro': '1500 Euro',
    '10000 Euro': '10000 Euro',
    'Urgjenca Mjekesore & Riatdhesim': 'Urgjenca Mjekesore & Riatdhesim',
    'Franchise Limit': 'Limiti i ekskluzivitetit',
    'Deductible Limit': 'Limiti i zbritshëm',
    'Event Limit': 'Limiti i ngjarjeve',
    'Person Limit': 'Limiti i personit',
    'Period Limit': 'Kufizimi i periudhës',
    'Limit Types': 'Llojet e kufirit',
    Enabled: 'Aktivizuar',
    Value: 'Vlera',
    'Channel Type': 'Lloji i kanalit',
    'Scope Type': 'Lloji i shtrirjes',
    Reason: 'Arsyeja',
    ValueCamelCase: 'Vlera',
    Max: 'Maks',
    Min: 'Min',
    MinValue: 'Vlera Minimale',
    MaxValue: 'Vlera Maksimale',
    Premium: 'Premium',
    Flat: 'E sheshtë',
    'Sum Insured': 'Shuma e siguruar',
    'Payment Type': 'Lloji i pagesës',
    Health: 'Shëndeti',
    Coverages: 'Mbulime',
    Age: 'Mosha',
    'Livestock Type': 'Tipi i bagëtive',
    'Culture Type': 'Tipi i kultures',
    Area: 'Sipërfaqja',
    'Greenhouse Article Type': 'Tipi i artikullit të serës',
    'Greenhouse Property Type': 'Tipi i pronës së serës',
    Identification: 'Identifikimi',

    'Insured Amount': 'Shuma e siguruar',
    Template: 'Model',
    days: 'ditë',
    months: 'muaj',
    years: 'vite',
    'Number of Days': 'Numri i ditëve',
    'Iosa ID': 'Iosa ID',
    'User Iosa ID': 'Përdoruesi Iosa ID',
    'Broker Code': 'Kodi Broker',
    'Display Name Full': 'Emri dhe Mbiemri',
    'Property Number': 'Numri i pasurisë',
    'Cadastral Area': 'Zona Kadastrale',
    Nr: 'Nr',
    'Property Type': 'Lloji i pronës',
    Article: 'Artikujt',
    'Unique Code': 'Kodi unik',
    'Surface Area': 'Sipërfaqja',
    'Object name': 'Emri i objektit',
    'Travel Cancelation Date': 'Data e konfirmimit të biletës',
    'Cadastral Zone': 'Zona Kadastrale',
    Dates: 'Datat',
    'Passport Number': 'Numër Pasaporte',
    'Beneficiary 2': 'Përfituesi 2',
    Owner: 'Pronari',
    'Waiting Period': 'Periudha e pritjes',
    'Select an insurer': 'Zgjidhni një sigurues',
    Invoice: 'Fatura',
    Albanian: 'Shqiptar',
    'No-Albanian': 'Jo-Shqiptar',
    'Release Date': 'Data e lëshimit',
    'Policy description': 'Përshkrimi i policës',
    'Full Name': 'Emri i plotë',
    'Related Agency': 'Agjencia e lidhur',
    'Issue Date': 'Data e lëshimit',
    'options.years': 'vite',
    'options.year': 'vit',
    'options.months': 'muaj',
    'options.month': 'muaj',
    'options.days': 'dite',
    'options.day': 'dite',
    Insurer: 'Siguruesi',
    'Territorial Coverage': 'Mbulimi Territorial',
    ClientFromBank: 'Klienti nga Banka',
    DescriptionFromBank: 'Përshkrimi nga Banka',
    'Account Type': 'Lloji i llogarise',
    'Account Number': 'Numri i llogarise',
    'Bank Code': 'Banka',
    'Bank Branches': 'Degët e bankes',
    'Activity Address': 'Adresa e aktivitetit',
    'Retroactive Date': 'Data Prapavepruese',
    Specification: 'Specifikim',
    'License Number': 'Numri i Licencës',
    Project: 'Projekti',
    'Preventive Value': 'Vlera e preventivit',
    NIPT: 'NIPT',
    Publication: 'Publikimi',
    'Reference Number': 'Numri i referencës',
    'Procurement Method Type': 'Lloji i metodës së prokurimit',
    'Pershkrim / objekti i tenderit': 'Pershkrim / objekti i tenderit',
    'Data fillimit / tenderit': 'Data fillimit / tenderit',
    'Issued Date From': 'Date leshimi nga:',
    'Issued Date To': 'Date leshimi deri:',
    'Cashed premium': 'Primi i arketuar',
    'Fuel Station Capacity': 'Kapaciteti',
    'Fuel Station Address': 'Adresa',
    'Fuel Station License Number': 'Numri i Liçencës',
    'Fuel Station Activity License': 'Liçenca e Aktivitetit',
    'Fuel Station Authorization Number': 'Numri i Autorizimit',
    'Eurobroker Code': 'Kodi Eurobroker',
    'Eurobroker Username': 'Emri i përdoruesit Eurobroker',
    'Eurobroker Password': 'Fjalëkalimi Eurobroker',
    Profession: 'Profesioni',
    Renewal: 'Rinovim',
    'Line Of Business': 'Linja e Biznesit',
    'Property Valuation Type': 'Lloji i vlerësimit të pronës',
    Index: 'Indeksi',
    'Excise Number': 'Numri i Akcizës',
    'Contract Date': 'Data e kontratës',
    'Insured Profession': 'Profesioni i Siguruar',
    'Covered Project': 'Projekt i mbuluar',
    'Age expression': 'Age expression',
    Custom: 'Custom',
    'Period Amount': 'Period Amount',
    'Period Type': 'Period Type',
    'SubLimit Type': 'SubLimit Type',
    'Gender Type': 'Gender Type',
    'Age Expression': 'Age Expression',
    'Sublimit Type': 'Sublimit Type',
    'Is Reinsurance': 'Risigurim',
    'Product reinsurance': 'Risigurimi i produktit',
    'Driving License': 'Leje Drejtimi',
    'Vehicle Type': 'Lloji i automjetit',
    'Region Type': 'Zona',
    'Owner NID': 'NID i pronarit',
    'Health Coverage Amount': 'Masa e mbulimit',
    'Vessel Flag': 'Flamuri i mjetit lundrues',
    _Order: 'Vendimi',
    'Registration Number': 'Nr. Pasurie',
    'Panel power': 'Fuqia paneleve',
    'Concession Object Type': 'Lloji i objektit të koncesionit',
    'Account No': 'Nr llogarise',
    IBAN: 'IBAN',
    Activity: 'Aktiviteti',
    'Navigation Area': 'Zona e Navigimit',
    'Search Country': 'Kërko shtetin',
    'Go to bank account': ' Shko tek llogarite bankare',
    'Production Year': 'Viti i prodhimit',
    'Is Rent': 'Është me qira',
    'Vessel Display Name': 'Emri i mjetit lundrues',
    'Vessel Category': 'Kategoria e mjetit lundrues',
    'Vessel Material': 'Materiali i mjetit lundrues',
    'Engine Power': 'Fuqia e Motorrit',
    'Unique Registration Number': 'Numri Unik i Regjistrimit',
    'Vessel Name': 'Anija',
    'Cargo Description': 'Përshkrimi i ngarkesës',
    'Vehicle Plate': 'Targa e mjetit',
    'Container Name': 'Emri i kontainerit',
    'Container Number': 'Numri i kontainerit',
    'Airline Name': 'Emri i linjës ajrore',
    'Extra Explanations': 'Shpjegime shtesë',
    'Transport Documents': 'Dokumentet e transportit',
    'Package Type': 'Lloji i paketës',
    'Voyage Origin': 'Origjina e udhëtimit',
    'Transportation Type': 'Lloji i transportit',
    'Voyage Destination': 'Destinacioni i udhëtimit',
    'Cargo Type': 'Lloji i ngarkesës',
    'Hide Premium': ' Fshih primin',
    Dimensions: 'Dimensionet',
    'Voyage Destionation': 'Destinacioni i udhëtimit',
    'Installment Number': 'Numri kesteve',
    'Interest Rate': 'Norma interesit',
    'Yearly Premium': 'Primi vjetor per vitin e pare',
    'Monthly Premium': 'Primi mujor',
    'Insurance Premium Fee': 'Tarifa primit sigurimit (%)',
    'Broker Name': 'Emri i Broker',
    'Broker ID': 'Broker ID',
    'Serial Code': 'Kodi i serialit',
    'Nr. Serial Polica (Shumë)': 'Nr. Serial Polica (Shumë)',
    'Separate serial numbers with "," or space': 'Ndani numrat serial me "," ose hapesire',
    Sequence: 'Sekuenca',
    'Product Category Path': 'Product Category Path',
    'Is Esig Fisc Activated': 'Is Esig Fisc Activated',
    'Vehicle license plates': 'Targat e automjetit',
    'Extra Notes': 'Shënime shtesë',
    'Number Of Vehicles': 'Numri i automjeteve',
    'Daily Exchange Rate': 'Kursi Ditor',
    'Posted on': 'Data e postimit',
    'Invoice exchange rate': 'Kursi i faturës',
    Account: 'Llogaria',
    'Collection / Payment (Invoice Currency)': 'Arketim / Pagese Mon. Fat.',
    'Collection / Payment (Local Currency)': 'Arketim / Pagese Mon. LCY',
    'New Balance (Invoice Currency)': 'Balanca e re Mon. Fat.',
    'New Balance (Local Currency)': 'Balanca e re Mon. LCY',
    'Balance ALL': 'Balanca ALL',
    'Save invoices as mandate entries': 'Ruaj faturat si ze mandati',
    'List of balances': 'Lista e balancave',
    'Calculate balance': 'Llogarit balancen',
    'Mark as exchange loss': 'Sheno si humbje kursi',
    'Display the balance': 'Afisho balancen',
    Restart: 'Rifillo',
    Action: 'Veprimi',
    'Explicit Number Of Vehicles': 'Numri i saktë i automjeteve',
    'Selekto llojin e llogarise': 'Selekto llojin e llogarise',
    'Is Sailing Vessel': 'Është një anije me vela',
    'Sail Area': 'Siperfaqja e velave',
    'Total Passanger Number': 'Numri Total i Pasagjerëve',
    'Insured Risks': 'Rreziqet e Siguruara',
    'Usage Purpose': 'Qëllimi i Përdorimit',
    'Pilot Names': 'Emrat e Pilotëve',
    'Territorial Limit': 'Limiti Territorial',
    'Vessel Model': 'Modeli i anijes',
    'Gross Tonnage': 'Tonazh Bruto',
    'Certification Number': 'Numri i Certifikatës',
    Skipper: 'Kapiteni',
    'Sailing Region': 'Rajoni i Lundrimit',
    Importi: 'Importi',
    'Insured Location': 'Insured Location',
    'Number of Employees': 'Number of Employees',
    'common.ProductType': 'Tipi i produktit',
    'common.Search': 'Kerko',
    'common.ProductSerial': 'Seriali i polices',
    'Age (Years)': 'Mosha  (Vite)',
    'Age (Months)': 'Mosha (Muaj)',
    'Kod Agjenti': 'Kod Agjenti',
    'Policy Product': 'Produkti i policës',
    'Policy Status': 'Statusi i polices',
    'Client Tax Number': 'Klient Numri Tax',
    Search: 'Search',
    Make: 'Marka',
    Model: 'Modeli',
    'Serial Number': 'Numri Serial',
    'Invoice Number': 'Numri i Fatures',
    'Purchase Price': 'Cmimi i Blerjes',
    'Purchase Currency': 'Valuta e Blerjes',
    'Seller Warranty Start Date': 'Data e Fillimit te Garancise se Shitesit',
    'Seller Warranty End Date': 'Data e Perfundimit te Garancise se Shitesit',
    'From End Date': 'Nga Data e Përfundimit',
    'To End Date': 'Deri në Datën e Përfundimit',
    billablePremiumAmount: 'Vlera e primit qe do faturohet',
    manualAdjustedPremium: 'Nëse dëshironi të ndryshoni vlerën e faturuar',
};
